var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8528_50108",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00488 6C4.00488 4.89543 4.90031 4 6.00488 4L41.9953 4C43.0998 4 43.9953 4.89543 43.9953 6L43.9953 42C43.9953 43.1046 43.0998 44 41.9953 44L6.00488 44C4.90032 44 4.00488 43.1046 4.00488 42L4.00488 6Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8528_50108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9708 21.8505L1.27148 1.44564L12.5084 -4.46875L21.9708 21.8505Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1028 24.0001L37.3383 -9.87537L49.8204 -0.294031L25.1028 24.0001Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.119 23.1458L-7.2979 18.0666L-1.94883 8.57432L17.119 23.1458Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1312 30.1239L48.1201 36.944L42.103 46.0275L24.1312 30.1239Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3508 27.6127L26.756 51.9595L15.904 50.9845L21.3508 27.6127Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 21.8498L17.2485 -6.54299L29.8925 -5.37055L23.4668 21.8498Z",
    fill: "#D2D0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.852 27.3002L50.8059 16.4232L51.7635 29.0854L23.852 27.3002Z",
    fill: "#D2D0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3413 26.0335L-8.8308 33.1858L-8.07638 20.5099L19.3413 26.0335Z",
    fill: "#D2D0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9134 26.4044L6.22838 48.7244L-1.25089 40.0704L19.9134 26.4044Z",
    fill: "#D2D0FB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenGlass);
export default __webpack_public_path__ + "static/media/brokenGlass.f30be1753facf4c894377fa97b10bd52.svg";
export { ForwardRef as ReactComponent };